<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Название сторис</span>
            <span class="w-2/3">{{ entity.title }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Время показа</span>
            <span class="w-2/3">{{ entity.show_time }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Позиция показа</span>
            <span class="w-2/3">{{ entity.position }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Название кнопки</span>
            <span class="w-2/3">{{ entity.button_name }} </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Цвет кнопки</span>
            <span class="w-2/3">{{ entity.color_button }} </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Ссылка</span>
            <span class="w-2/3">{{ entity.link }}</span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'StoriesCard',
        components: {},
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },
        mounted() {
            console.log(this.entity);
        },
    };
</script>
